(function( $, root ){
  $(function(){
    'use strict';
    console.log('> main: init');

    
      if( !$('body').hasClass('page-landing') ){
        
        $(window).on('load', function(){
          $('body').addClass('page-loaded');
        
          if( $('body').hasClass('index') ){
            setTimeout(function(){
              $('.js--animation').addClass('js--animation--page-loaded');
            }, 1500);
    
            setTimeout(function(){
              loadIntroAnimations();
              $('.loader--container').remove();
            }, 2500);
          }else{
            setTimeout(function(){
              $('.js--animation').addClass('js--animation--page-loaded');
            }, 0);
    
            setTimeout(function(){
              loadIntroAnimations();
            }, 200);
          }
  
          if( $('body').attr('class').indexOf('product') >= 0 ){
            $('.product__media--video video').play();
            console.log('auto playing here')
          }
      });
      
    }else{
      
      $(document).ready(function(){
          $('body').addClass('page-loaded');
        
          $('.js--animation').addClass('js--animation--page-loaded');
  
          setTimeout(function(){
            loadIntroAnimations();
          }, 200);

          if( $('body').attr('class').indexOf('product') >= 0 ){
            $('.product__media--video video').play();
            console.log('auto playing here')
          }
        
      })
      
    }

    $(document).on( "mouseenter", '.js--animation', function(){
        $(this).addClass('js--animation--hover');
      } 
    ).on( "mouseleave", '.js--animation', function(){
        $(this).removeClass('js--animation--hover');
      
    } );
    
    $(window).on("load resize", function () {

      
      var sliders = [
        $('.section--what-they-are-saying .slider-mobile-gutter:not(.slider-mobile-gutter--no-slider) ul.multicolumn-list'),
        $('.section-follow-us .slider-mobile-gutter:not(.slider-mobile-gutter--no-slider) ul.multicolumn-list'),
        $('.slider-mobile-gutter:not(.slider-mobile-gutter--no-slider) .grid.product-grid'),
      ];

      let init = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      }
      
      if ( $(window).width() < 576) {
        
        sliders.forEach( function (element, index) {
          element.not(".slick-initialized").slick(init);
        });
        
      } else {

        sliders.forEach( function ( element, index ){
          if( element.hasClass("slick-initialized") ){
            element.slick("unslick");
          }
        } );
        
        
        
      }
    });



    $(document).on('load', function(){
      
    });
    $(document).on('click', '.products-filters a[data-filter]', function(e){
      e.preventDefault();

      let button = $(this);
      const collectionTarget = button.attr('data-filter');
      const collectionPath = button.attr('data-collection-path');

      let showedProductsCount = 0;

      if( collectionPath ){
          history.pushState('', '', collectionPath);
      }
      if( collectionTarget ){
        
        $('.slider-mobile-gutter li.slider__slide').each(function(){
            let productCollections = $(this).attr('data-collections');

          $(this).hide();
          
          if( productCollections.includes(collectionTarget) ){
            $(this).show();
            showedProductsCount += 1;
            
          }
        });
      }

      console.log(showedProductsCount);

      if( showedProductsCount == 0){
        $('.js--collection-empty-message').css('display', 'block');
      }else{
        $('.js--collection-empty-message').css('display', 'none');
      }
      
    });


    $('.js--show-more-reviews').on('click', function(){
      $(this).parents('.product-reviews--reviews').find('.review-item').show();
      $(this).remove();
    })



    $('.js--featured-collection-products').on('change', function(){
      let selectedOptionUrl = $(this).find(":selected").val();
      window.location.href = selectedOptionUrl;
    });



    $(document).click(function(event) { 
      var $target = $(event.target);
      if( 
        !$target.closest('.js--slidable-image .nutritional-facts--wrap').length &&  
        $('.js--slidable-image').hasClass('active') 
      ) {
        $('.js--slidable-image').removeClass('active');
        window.location.hash = '';
        
      }        
    });
    $(window).ready(function() {
      let hash = window.location.hash;
      if( hash == "#view-ingredients"){
          $('.nutritional-facts').addClass('active');
        }
    });
    $( window ).on( 'hashchange', function( e ) {
        let hash = window.location.hash;
        if( hash == "#view-ingredients"){
          $('.nutritional-facts').addClass('active');
        }else{
          $('.nutritional-facts').removeClass('active');
          
        }
    } );

    $('.js--close-slidable-image').on('click', function(){
      window.location.hash = '';
    })


    let style = document.createElement( 'style' );
    style.className = "global-style";
    style.innerHTML = '.rc-purchase-option{ background: transparent !important; } .rc-purchase-option__checked-indicator{border: 0 !important} rc-radio-icon > * {display: none !important;} .rc-purchase-option__prices{display: flex;flex-direction: row !important;gap: 20px;} input:checked + rc-radio-icon::before{background:#000 !important;} rc-radio-icon::before{content:"";width:20px;height:20px;min-width:20px;min-height:20px;max-width:20px;max-height:20px;display:inline-block;border-radius:100% !important;outline:3px solid #000;border:3px solid #FFF;background:#fff;} .rc-purchase-option__label { padding: 0 !important; }.rc-purchase-option__sub-container{padding: 0 !important;}.rc-purchase-option{border: 0 !important;}'
    
    
    
    

    let rechargeSubscriptionInterval = setInterval(function(){
      // console.log('interval, recharge-subscription-widget')
      if( document.querySelector('recharge-subscription-widget') ){
        
        let host = document.querySelector('recharge-subscription-widget');
        let radios = host.shadowRoot.querySelectorAll('rc-radio-icon');
        let select = host.shadowRoot.querySelectorAll('rc-selling-plans');

        // console.log( host.shadowRoot.querySelector('.global-style') )
        if( !host.shadowRoot.querySelector('.global-style') ){
          console.log('global style applied');
          host.shadowRoot.appendChild( style )
        }
        
        if(select){
          host.shadowRoot.querySelectorAll('rc-selling-plans').forEach( e => {

            let selectSheet = document.createElement( 'style' );
            selectSheet.className = "select-style";
            selectSheet.innerHTML = ` .rc-plans-dropdown{ width: 100%; height: 50px; display: inline-block; }.rc-plans-dropdown::before{content:"";display:block;height:50px;width:65px;position:absolute;border-left:3px solid var(--color-black);right:0;transform:translateY(-50%);top:50%;z-index:-1;background-image:url(/cdn/shop/files/Trazado_36315.svg?v=1734791157);background-size:19px;background-position:center;background-repeat:no-repeat;z-index:1;pointer-events:none;} .rc-plans-dropdown > .rc-plans-dropdown__select{width:100%;font-weight:700;margin:0;font-size:21px;padding:5px 100px 5px 24px;border-radius:100px;height:50px;font-family:var(--font-link);background:#fff0;border:3px solid #000;-webkit-appearance:none;appearance:none;color:var(--color-black);}.rc-plans-dropdown > svg{display: none;}`;
            
                    
            if( !e.shadowRoot.querySelector('.select-style') ){
              console.log('select style applied', e);
              e.shadowRoot.appendChild( selectSheet );
            }
          });
        }
        
        if( radios ){
          host.shadowRoot.querySelectorAll('rc-radio-icon').forEach( (e, i) => {
            // console.log('rc-radio-icon', i, e);

            var radiosSheet = document.createElement( 'style' );
            radiosSheet.className = "radio-style";
            radiosSheet.innerHTML =  `svg{ display: none !important; }`;
            
            if( !e.shadowRoot.querySelector('.radio-style') ){
              console.log('radio styles applied');
              e.shadowRoot.appendChild( radiosSheet );
            }

            
          });
        }
        
        
      }
    }, 10);

    //host is the element that holds the shadow root:
    $(`.shopify-section h2, .multicolumn-list h3, .multicolumn-list h3, .multicolumn-card__info--title h4, body.page-landing h3`).each(function(){
      let hTag = $(this);

      // hTag.html( hTag.html().replace('&amp;', '&') );
      hTag.html( hTag.html().trimStart().trimEnd() );

      // let pattern = new RegExp("^([^<]*)<\w+.*/\w+>([^<]*)$");

      // hTag.html( '<div style="display: inline;">' + hTag.html() + '</div>' );
      // hTag.find('strong').each(function(){
      //   $(this).html( '<div style="display: inline;">' + $(this).html() + '</div>' );
      // });

      // hTag.html( hTag.html().replace( /(simple)(?![^<>]*>)/g, 'a') );
      // hTag.html( hTag.html(). );

      // hTag.find('strong').each(function(){
        
      // });

      // console.log( hTag.html().split(' ') );
      // console.log( hTag.html().split(' ') );

      // hTag.prepend('<div style="display: inline;">');
      // hTag.append('</div>');
      
      hTag.html(function(index, html) {

        
        
        let newHTML = html;
        
        

        
        
        
        newHTML = newHTML.replace(/<[^<>]+>|./g, '<span>$&</span>');
        newHTML = newHTML.replace(/\s/g, '&nbsp;');
        newHTML = newHTML.replace('<span>a</span><span>m</span><span>p</span><span>;</span>', '');
        

        return newHTML;
      });

      hTag.find('strong').each(function(){
        $(this).html( '<div>' + $(this).html() + '</div>' );
      });
      hTag.html( '<div>' + hTag.html() + '</div>' );
      hTag.html( hTag.html().replaceAll( '<span>&nbsp;</span>', '</div><span>&nbsp;</span><div>') );
      hTag.find('strong').each(function(){
        $(this).unwrap();
      });
      hTag.find('div').each(function(){
        if ($(this).is(':empty')) { 
          $(this).remove();
      } 
      });

      
      
    });
    
    
    
    $(window).scroll(function(){
      
      if( $('body').hasClass('page-loaded') ){
        loadIntroAnimations();
      }
                                    
    });

    $( window ).on( 'hashchange', function( e ) {
      if( $('body').hasClass('page-loaded') && $('body').hasClass('page-landing') ){
        setTimeout(function(){
          loadIntroAnimations();
        }, 1000);
      }
    });
      
      
                                    


    
    // let currentIcon = $('.footer-block__animated-face .footer-block__animated-face--icons img.active').each(function(i, elTarget){
    
    //       let animation = anime({
    //         easing: 'easeOutQuinte',
              
    //         targets: elTarget,
    //         keyframes: [
    //           {rotate: 0},
    //           {rotate: 720},
    //         ],
    //         speed: 400,
    //         delay: 3000,
    //         complete: function() {
    //           animation.restart();
    //         }
    //       });
    
    // });

    

    
    
  });
})( jQuery, this );

function loadIntroAnimations(){

  console.log('> loadIntroAnimations: animate')

  var elementsToAnimate = [
      '.shopify-section h2', 
      '.multicolumn-list h3', 
      '.multicolumn-card__info--title h4',
      
      '.rich-text__content p', 
      '.richtext p', 
      '.multicolumn-card__info p', 
      '.rte p',
      
    
      '.section--what-they-are-saying .multicolumn-card__image-wrapper .media :is(.image-icon--first,.image-icon--second) img',
      '.section--plant-based-snacks  .multicolumn-card__image-wrapper .media',

      '.section--benefits-checkmarks ul li',
      '.section--s-and-s-how-it-works .items .items--item .items--item-content',
      '.section--s-and-s-how-it-works .items .items--item .items--item-image img',

      'body.page-landing .group--page-content-wrapper h3',
      'body.page-landing .group--page-content-wrapper p',
    ];
  
  elementsToAnimate.forEach( element => {
      $( element ).each(function( i, elTarget){


        let screenTop = $(document).scrollTop();
        let screenBottom = $(document).scrollTop() + $(window).height();

        let el = $(this);
        let tag = el.prop("tagName"); 

        let elTopDistance = el.offset().top;
        let elBottomDistance = el.offset().top + el.outerHeight();


        if( screenBottom - 100 > elTopDistance && screenTop + 100 < elBottomDistance ){
          el.addClass('element-on-screen');
          animateIntro( el, tag, elTarget, i );
        }else{
          el.removeClass('element-on-screen');
          animateOutro( el, tag, elTarget, i );
        }
        
      });
    });
}

function animateIntro( el, tag, elTarget, index ){
  
  switch(tag){
    case "H2":
    case "H3":
    case "H4":
      // console.log('h2 intro');

      el.find('span:not(.animated)').each(function( i, span ){

        $(this).removeClass('out-of-screen');
        anime({
          targets: span,
          easing: 'easeOutQuint',
          translateY: [-10, 0],
          translateX: [-10, 0],
          scale: [0, 1.3, 1],
          rotate: [0, -5, 0],
          speed: 0.6,
          delay: 3 * i
        });
        $(this).addClass('animated');
        
      });
      break;

    case "P":
      // console.log('p intro');
      el.removeClass('out-of-screen');
      if( !el.hasClass('animated') ){
        anime({
            targets: elTarget,
            easing: 'easeOutElastic',
            translateY: [50, 0],
            opacity: [0, 1],
            speed: 0.8,
            delay: 300
        });
      }
      el.addClass('animated');
      break;


    case "IMG":
      el.removeClass('out-of-screen');
      if( !el.hasClass('animated') ){
        anime({
            targets: elTarget,
            easing: 'easeOutElastic',
            scale: [0, 1],
            translateX: [-40, 0],
            speed: 0.8,
            delay: 300
        });
      }
      el.addClass('animated');
      break;

    case "DIV":

      if( el.hasClass('media') ){
        el.removeClass('out-of-screen');
        if( !el.hasClass('animated') ){
          anime({
              targets: elTarget,
              easing: 'easeOutElastic',
              scale: [0, 1],
              translateX: [-40, 0],
              speed: 0.8,
              delay: 200 + ( 100 * index )
          });
        }
        el.addClass('animated');
      }

      if(el.hasClass('items--item-content')){
        el.removeClass('out-of-screen');
        if( !el.hasClass('animated') ){
          anime({
              targets: elTarget,
              easing: 'easeOutElastic',
              translateY: [50, 0],
              opacity: [0, 1],
              speed: 0.8,
              delay: 300 + 200 * index
          });
        }
        el.addClass('animated');
      }
      
      break;


    case "LI":

      if( el.parents('.section--benefits-checkmarks') ){
        el.removeClass('out-of-screen');
        if( !el.hasClass('animated') ){
          anime({
              targets: elTarget,
              elasticity: 300,
              scale: [0, 1],
              speed: 0.5,
              delay: 200 + ( 200 * index )
          });
        }
        el.addClass('animated');
      }
      
      break;
  }
}

function animateOutro( el, tag, elTarget, index ){
  switch(tag){
    case "H2":
    case "H3":
    case "H4":
      // console.log('h2 outro');
      el.find('span:not(.out-of-screen)').each(function( i, span ){

        $(this).removeClass('animated');
        anime({ 
          targets: span,
          easing: 'linear',
          translateY: [0],
          translateX: [0],
          scale: [1, 0.001],
          rotate: [0],
          speed: 0.1,
          delay: 0
        }); 
        $(this).addClass('out-of-screen');
        
      });
      
      break;

    case "P":
      el.removeClass('animated');
      if( !el.hasClass('out-of-screen') ){
        anime({
          targets: elTarget,
          easing: 'linear',
          translateY: [0, 50],
          opacity: [1, 0],
          speed: 0.1,
          delay: 0
      });
      }
      el.addClass('out-of-screen');
      break;

    case "IMG":
      el.removeClass('animated');
      if( !el.hasClass('out-of-screen') ){
        anime({
            targets: elTarget,
            easing: 'easeOutElastic',
            scale: [1, 0],
            translateX: [0, -40],
            speed: 0.5,
            delay: 300
        });
      }
      el.addClass('out-of-screen');
      break;

    case "DIV":
      
      if( el.hasClass('media') ){
        el.removeClass('animated');
        if( !el.hasClass('out-of-screen') ){
          anime({
              targets: elTarget,
              easing: 'easeOutElastic',
              scale: [1, 0],
              translateX: [0, -40],
              speed: 0.5,
              delay: 200 + ( 100 * index )
          });
        }
        el.addClass('out-of-screen');
      }

      
      if(el.hasClass('items--item-content')){
        el.removeClass('animated');
        if( !el.hasClass('out-of-screen') ){
          anime({
              targets: elTarget,
              easing: 'linear',
              translateY: [0, 50],
              opacity: [1, 0],
              speed: 0.1,
              delay: 0
          });
        }
        el.addClass('out-of-screen');
      }

      
      break;


    case "LI":
      
      if( el.parents('.section--benefits-checkmarks') ){
        el.removeClass('animated');
        if( !el.hasClass('out-of-screen') ){
          anime({
              targets: elTarget,
              easing: 'linear',
              scale: [1, 0],
              speed: 0.3,
              delay: 0
          });
        }
        el.addClass('out-of-screen');
      }
      break;
      
  }
}